import { Http } from './http';

class LookerHttp extends Http {
  prefix = 'looker';

  async getLook(lookId: number): Promise<LookerRecord[]> {
    const url = `/look/${lookId}`;
    const res = await this.get<LookerRecord[]>(url);

    return res.data;
  }
}

export const lookerHttp = new LookerHttp();

export type LookerRecord = Record<string, string | number>;
